import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL_STATE = { name: '', email: '', message: '' };

export const useContactForm = () => {
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API}/contacts`, formData);
      if (response.data.success) {
        toast.success('Messaggio inviato!', {
          description: 'Ti risponderemo al più presto.',
        });
        setFormData(INITIAL_STATE);
      }
    } catch (error) {
      toast.error('Errore', {
        description:
          error.response?.data?.error ||
          'Impossibile inviare il messaggio. Riprova più tardi.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, handleChange, handleSubmit };
};
